/**
 * Created by OBL on 14/01/2016.
 */
define('adminLisController',[
    'module',
    'underscore',
    'app',
    'adminLisView',
    'bootbox',
    'lisCreateEditLayoutView',
    'settings',
    'entities/lis'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var SuperAdminLisListController = {
        showLisList: function(data) {
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'lis:delete', _.bind(this.onDelete, this));
            App.regions.getRegion('main').currentView.getRegion('content').show(view);
        },

        showLisAdd: function() {
            this.createEditView = new CreateEditLayoutView({
                lisModel: App.request('lis:model'),
                newItem: true
            });
            this.createEditView.show({
                title: _.i18n('lis.new')
            });
        },

        onGridLoaded: function() {
            var data = {
                url: App.request('lis:get-collection-url'),
                rowCountUrl: App.request('lis:get-count-url')
            };

            this.view.displayGrid(data);
        },

        onDelete: function(secId){
            bootbox.confirm(_.i18n('lis.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('lis:delete', secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = SuperAdminLisListController;
});
